(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tt-tape-finder"] && !Shopify.designMode) return;
  try {
    function initTapeFinders(){document.querySelectorAll('[data-tape-finder]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelector('form').addEventListener('submit',event=>{event.preventDefault();const job=root.querySelector('#tt-finder-job');const surface=root.querySelector('#tt-finder-surface').value;const conditions=root.querySelector('#tt-finder-conditions').value;const special=job.value==='leak'||conditions==='immersed';root.querySelector('[data-check]').hidden=special;root.querySelector('[data-delicate]').hidden=special||!(surface==='painted'||conditions==='removal');root.querySelector('[data-exposure]').hidden=special||conditions!=='outdoor';root.querySelector('[data-special]').hidden=!special;const link=root.querySelector('[data-guide]');link.hidden=special;link.href=job.selectedOptions[0].dataset.url;const result=root.querySelector('[data-result]');result.hidden=false;result.focus();});});}initTapeFinders();document.addEventListener('shopify:section:load',initTapeFinders);
  } catch(e) { console.error(e); }
})();

})();
